/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
const { browserDocument, toKebabCase } = require('./src/utils')

exports.onRouteUpdate = ({ location, prevLocation }, ...props) => {
  /* For Google User ID Reporting
  const user = storage.getItem('userId')

  if (user) {
    window.analytics && window.analytics.page(user)
  }
  */

  const pathname = location.pathname.split('/')

  let id
  if (pathname[pathname.length - 1].length > 0) {
    id = pathname[pathname.length - 1]
  } else {
    id = pathname[pathname.length - 2]
  }

  let article
  if (browserDocument) {
    article = browserDocument.getElementById(id)
  } else {
    article = null
  }

  if (article) {
    Array.from(article.getElementsByTagName('h2')).forEach(element => {
      const sectionId = toKebabCase(element.innerText.replace(/<\/?h2>/g, '').replace(/<\/?strong>/g, ''))

      element.setAttribute('id', sectionId)
    })
  }
}
